import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
import { TweenMax, TimelineMax } from 'gsap';
import { createEFPic } from '@/utils/useEFPic';
const { EFPic } = createEFPic('/media/dg200/');

export default function ImgTextC() {
    const { useLang, isMobile, useEffect } = useGlobal();
    const { t } = useLang('dualfuelsmartgenerator');

    const layoutH = typeof window !== 'undefined' ? window.innerHeight : 1042;
    let controller: any;
    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    useEffect(() => {
        if (!isMobile) {
            const scene1 = new ScrollMagic.Scene({
                triggerElement: '.imgTextC',
                offset: 100,
                triggerHook: 1,
                duration: 400,
            });
            const timeline = new TimelineMax();
            const tween1 = TweenMax.fromTo(
                '.imgTextC .title',
                0.5,
                {
                    opacity: 0,
                },
                {
                    opacity: 1,
                },
            );
            const tween2 = TweenMax.fromTo(
                '.imgTextC .desc',
                0.5,
                {
                    opacity: 0,
                },
                {
                    opacity: 1,
                },
            );
            const tween3 = TweenMax.fromTo(
                '.imgTextC .imgBox',
                0.5,
                {
                    opacity: 0,
                },
                {
                    opacity: 1,
                },
            );
            timeline.add(tween1).add(tween2).add(tween3);
            scene1.setTween(timeline);
            controller.addScene(scene1);
        }
    }, []);

    return (
        <div className={`imgTextC ${css.imgTextC} ${isMobile ? 'imgTextC_h5' : 'imgTextC_pc'}`}>
            <div className="container">
                <div className="textBox">
                    <p className="title">{t('dg200.imgTextC_title')}</p>
                    <p className="desc">{t('dg200.imgTextC_desc')}</p>
                </div>
                <div className="imgBox">
                    <EFPic
                        name={[`${isMobile ? 'h5/' : 'pc/'}3.webp`, `${isMobile ? 'h5/' : 'pc/'}3.jpg`]}
                        // layout="fill"
                        className="fullImgs"
                        alt={t('dg200.imgTextC_title')}
                        aria-label={t('dg200.imgTextC_title')}
                    />
                </div>
            </div>
        </div>
    );
}
